// TODO from Nikola: lowercase and hyphenate all these ID values. First double check whether these are used on GTM/GA/Amplitude, because changing these in code and not there will break the tracking.
// TODO from Nikola: remove the "Id" suffix from the keys - the enum name already implies this.
export enum ComponentIds {
  FeedStartAPost = 'FeedStartAPost',
  WidgetsContainerId = 'WidgetsContainerId',
  SearchbarId = 'SearchbarId',
  ProfileBoxId = 'ProfileBoxId',
  MarketOverviewTabContent = 'market-overview-tab-content',
  MarketPage = 'market-page',
  FavoriteContainerId = 'FavoriteContainerId',
  MessagesContainerId = 'MessagesContainerId',
  NavbarContainerId = 'NavbarContainerId',
  PortfolioPrivacyBtn = 'portfolioPrivacyBtn',
  NavProfile = 'navProfile',
  FirstPostFromFeed = 'firstPostFromFeed',
  OnboardingContainerId = 'OnboardingContainerId',
  AcademyContainerId = 'AcademyContainerId',
  CreatePortfolioButtonId = 'createPortfolioBtn',
  TopPortfoliosId = 'topPortfolioRankingCards',
  BottomMobileNavbarId = 'navbarMobile',
  HelpIconId = 'helpIcon',
}
